module.exports = __webpack_public_path__ + "img/avatar-shem-magnezi.816f023b.jpg";